import qs from 'qs';

import { api } from '../../api/api';

export type FicFidcTotalizerStatus =
  | 'available'
  | 'partial'
  | 'empty'
  | 'unavailable'
  | 'error';

export type FicFidcTotalizerReason =
  | 'none'
  | 'missing-data'
  | 'missing-parent'
  | 'empty'
  | 'parent-not-found'
  | 'wallet-not-found'
  | 'operation-outside-wallet'
  | 'dependency-error';

export interface FicFidcTotalizersRequest {
  date: string;
  operationId: string;
  walletId: number | null;
  childOperationIds: string[];
}

export interface FicFidcTotalizersResponse {
  requestedCompetence: string;
  competence: string | null;
  status: FicFidcTotalizerStatus;
  reason?: FicFidcTotalizerReason;
  coverage: {
    parent: boolean;
    monitoredFunds: boolean;
    alerts: boolean;
  };
  parentVlPatrimLiq?: number | null;
  vl_patrim_liq?: number | null;
  monitoredFundsCount?: number | null;
  alertCount?: number | null;
}

export async function getFicFidcTotalizers(
  request: FicFidcTotalizersRequest,
): Promise<FicFidcTotalizersResponse> {
  const query = qs.stringify(
    {
      walletId: request.walletId,
      operationId: request.operationId,
      date: request.date,
      childOperationIds: request.childOperationIds,
    },
    { arrayFormat: 'repeat', encodeValuesOnly: true },
  );

  const { data } = await api.get<FicFidcTotalizersResponse>(
    `/meta-carteiras-fic-fidcs/totalizers?${query}`,
  );

  return data;
}
